module.exports = __webpack_public_path__ + "img/icon__sharp-error.30a3f600.svg";